import React from 'react';
import PropTypes from 'prop-types';

const RadioButtonGroup = ({groupName, inputName, onChangeFunction, onChangeValue}) => {
  return (
    <div>
      <span className="d-flex mb-2 fw-500 pb-1">{groupName}</span>
      <div className="d-flex gap-3 me-3 pb-2">
        <div className='gap-2 d-flex'>
          <input
            type="radio"
            className="form-check-input cursor-pointer"
            defaultChecked={true}
            id="includeRadio"
            name={inputName}
            checked={onChangeValue == 1}
            onChange={() => onChangeFunction(1)}
          />
          <label className="form-check-label">
            {' Include'}
          </label>
        </div>
        <div className='gap-2 d-flex'>
          <input
            type="radio"
            className="form-check-input cursor-pointer"
            id="excludeRadio"
            name={inputName}
            checked={onChangeValue == -1}
            onChange={() => onChangeFunction(-1)}
          />
          <label className="form-check-label">
            {' Exclude'}
          </label>
        </div>
        <div className='gap-2 d-flex'>
          <input
            type="radio"
            className="form-check-input cursor-pointer"
            id="mayContainRadio"
            name={inputName}
            checked={onChangeValue == 0}
            onChange={() => onChangeFunction(0)}
          />
          <label className="form-check-label">
            {' May Contain'}
          </label>
        </div>
      </div>
    </div>
  );
};

RadioButtonGroup.propTypes = {
  groupName: PropTypes.string,
  inputName: PropTypes.string,
  onChangeFunction: PropTypes.func,
  onChangeValue: PropTypes.number
};

export default RadioButtonGroup;

